import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'

class ReduxDatePicker extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    // Required
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,

    //Optional
    label: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    meta: PropTypes.object,
    handleInputRemoval: PropTypes.func,
    optionalClasses: PropTypes.string,
  }

  renderLabel(label) {
    const { disabled } = this.props

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault()
    this.props.handleInputRemoval()
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props
    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  handleChange = (value) => {
    this.props.input.onChange(value)
  }

  render() {
    const {
      input,
      label,
      meta: {
        touched,
        error
      },
      minDate,
      maxDate
    } = this.props

    const {
      handleInputRemoval,
      optionalClasses,
    } = this.props

    return (
      <div
        className={`input-container${optionalClasses ? ' ' + optionalClasses : ''}${touched && error ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        <div className={`input-container-inner${handleInputRemoval ? ' removable' : ''}`}>
          <DatePicker
            selected={input.value ? moment(input.value) : null}
            onChange={this.handleChange}
            minDate={minDate ? minDate : null}
            maxDate={maxDate ? maxDate : null}
            placeholderText="Select a date"
          />
        </div>
        {touched && error &&
          <div className="input-error-message">
            {error}
          </div>
        }
      </div>
    )
  }
}


export default ReduxDatePicker



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxDatePicker.js